export default __webpack_public_path__ + "static/media/ER2.845c5c80.png";